import { API_URL } from '../constants/index'
import { getRequest, postRequest } from './api'

export async function list(contractID, size, index, containsValues, orderByValues) {
  console.log('contractEmailList list called', contractID)
  const url = new URL(`${API_URL}contractEmailList/get-list`)

  const queryString = url.search

  const searchParams = new URLSearchParams(queryString)

  if (contractID !== null) {
    searchParams.append('contractID', contractID)
  }

  if (size !== null && size !== undefined) {
    searchParams.append('size', parseInt(size, 10) || 15)
  }

  if (index !== null && index !== undefined) {
    searchParams.append('index', parseInt(index, 10) || 0)
  }

  if (containsValues !== null && containsValues !== undefined) {
    searchParams.append('containsValues', containsValues)
  }

  if (orderByValues !== null && orderByValues !== undefined) {
    searchParams.append('orderByValues', orderByValues)
  }

  url.search = searchParams.toString()

  const newUrl = url.toString()

  return getRequest(newUrl)
}

export async function find(id) {
  return getRequest(`contractEmailList/edit/${id}`)
}

export async function save(values) {
  return postRequest(`contractEmailList/save`, values)
}

export function remove(values) {
  return postRequest(`contractEmailList/delete`, values)
}
